/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 2/18/2019.
 */

import {object, string} from 'yup'

export const loginModel = (intl) => {
    return object().shape({
        userName: string()
            .required(intl.formatMessage({id: "login.validation.userName.required"}))
            .trim().min(3, intl.formatMessage({id: "login.validation.userName.minSize"}))
            .trim().max(50, intl.formatMessage({id: "login.validation.userName.maxSize"})),
        password: string()
            .required(intl.formatMessage({id: "login.validation.password.required"}))
            .trim().min(6, intl.formatMessage({id: "login.validation.password.minSize"})),
    })
}

